import React from "react";
import { Phone } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1 md:col-span-2">
            <span className="text-2xl font-bold text-white">
              C-I-V-I-L-S-C-O-D-E
            </span>
            <div className="mt-4 text-gray-300">
              <p>
                Civilsphere Educational Services Pvt Ltd, <br />
                Ayyappa Soceity, Madhapur, <br />
                Hyderbad, 500081
              </p>
              <div className="mt-4 flex items-center">
                <Phone className="h-5 w-5 text-gray-300 mr-1" />
                <a
                  href="https://wa.me/917995467223"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-2 text-[#77c36f] hover:text-white transition-colors"
                >
                  +91-7995467223
                </a>
              </div>
            </div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              Company
            </h3>
            <ul className="mt-4 space-y-4 list-none p-0">
              <li>
                <a
                  href="/about"
                  className="text-base text-gray-300 hover:text-white"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/privacy-policy"
                  className="text-base text-gray-300 hover:text-white"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms-of-service"
                  className="text-base text-gray-300 hover:text-white"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-700 pt-8">
          <p className="text-base text-gray-400 text-center">
            © {new Date().getFullYear()} Civilscode. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
